import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { formatDate } from '@angular/common';
import { PharmGroupModel } from 'src/app/models/PharmGroupModel';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { ItemsService } from 'src/app/services/ItemsService';
import { LocalStorageService } from 'ngx-webstorage';
import Swal from 'sweetalert2';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';   ///=== for searching pop up
import { PreparationDetModel } from 'src/app/models/PreparationDetModel';
import { PharmGroupService } from 'src/app/services/PharmGroupService';
import { UnitsService } from 'src/app/services/UnitsService';
import { PreparationDetService } from 'src/app/services/PreparationDetService';
import { ItemsearchcatComponent } from '../itemsearchcat/itemsearchcat.component';

@Component({
  selector: 'app-prepration-line',
  templateUrl: './prepration-line.component.html',
  styleUrls: ['./prepration-line.component.css']
})
export class PreprationLineComponent implements OnInit {
  prepautoserial = 0;
  prepmasterID='';
  patientID ='';
  prepprotocolID ='';
  category  ='';
  drgserial  ='';
  drgName ='';
  perpDaose =0;
  cDSA ='';
  uOM ='';
  unName ='';
  prepDR  ='';
  prepFD  ='0';
  prepFU  ='';
  prepdisp = '0';
  prepsaved = '0';
  prepRout ='';
  prepDuration ='';
  prepImportant ='';
  preSolution ='';
  prepDone ='';
  prepTimeDone ='07:00 AM';
  prepPharmacy ='';
  categoryName ='';
  compCode ='1';
  userID ='sa';
  modifiedDate ='2022-01-01';
  screenTitle = 'Preparation Order Edit ';
  patientcode ='';
  protocol = '';
  wk_category = '';
  itemsList: ItemsModel[] = [];
  pharmGroupList: PharmGroupModel[] = [];
  unitsList: UnitsModel[] = [];
  finalunitsList :  UnitsModel[] = [];

  @Output() submitClicked = new EventEmitter<any>();
  constructor(public itemsservice : ItemsService,
              private dialogref: MatDialog,
              public items : ItemsModel,
              public pharmgroupService : PharmGroupService,
              public unitsService : UnitsService,
              public pharmgroup : PharmGroupModel,
              public PreMedicationSelectedData: PreparationDetModel,
              public preparationDetService :PreparationDetService,
              public storage: LocalStorageService,
              public dialogRef: MatDialogRef<PreprationLineComponent>,
              @Inject(MAT_DIALOG_DATA)public data: any)
              {
                this.prepautoserial = data.wk_autoserial,
                this.prepmasterID = data.wk_serial ,
                this.category = data.wk_category,
                this.wk_category = data.wk_category,
                this.drgserial = data.wk_itcode ,
                this.drgName = data.wk_itname,
                this.perpDaose = data.wk_dose ,
                this.uOM = data.wk_unit ,
                this.prepDuration = data.wk_duration,
                this.prepFD = data.wk_finaldose,
                this.prepFU = data.wk_prepFU,
                this.prepdisp = data.wk_dispensed,
                this.prepsaved = data.wk_saved  ,
                this.prepImportant = data.wk_important,
                this.preSolution = data.wk_soloution ,
                this.prepRout = data.wk_rout,
                this.patientcode = data.wk_patientcode,
                this.protocol = data.wk_protocol
              }

  ngOnInit(): void {
    this.retrivePharmGroupLookupTop();
    this.retriveItemsLookupCat();
    this.retriveUnitsLookupTop();
    this.retriveFinalUnitsLookupTop();
  }
  retriveItem(){
    this.itemsservice.getitems(this.drgserial,this.compCode).subscribe((data: ItemsModel) => {
      this.drgName = data.itTName;
      this.uOM = data.itUnit;

    })
  }
  retriveItemsLookupCat() {
    var ItemGroup ='Systematic'
    if(this.category == '1'){ItemGroup ='PreMedication'};
    if(this.category == '2'){ItemGroup ='Systematic'};
    if(this.category == '3'){ItemGroup ='Discharge'};


    this.itemsservice.getItemsLookupCat('All')
      .subscribe((data: ItemsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.itemsList[i] = data[i];
        }
      });
  }
  openDialog(){
    var ItemGroup ='Systematic'
    if(this.category == '1'){ItemGroup ='PreMedication'};
    if(this.category == '2'){ItemGroup ='Systematic'};
    if(this.category == '3'){ItemGroup ='Discharge'};

    const dialogRef = this.dialogref.open(ItemsearchcatComponent,
      {
        data: {
          dataKey: this.items,
          detcategory : ItemGroup
        }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
       dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.drgserial = result.itCode;
        this.drgName = result.itTName;
        this.uOM = result.itUnit;

        dialogSubmitSubscription.unsubscribe();
      });


  }
  retrivePharmGroupLookupTop() {
    this.pharmgroupService
      .getPharmGroupLookupTop(this.storage.retrieve('stgcompCode')).subscribe((data: PharmGroupModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.pharmGroupList[i] = data[i];
        }

      });
  }
  retriveUnitsLookupTop() {
    this.unitsService
      .getUnitsLookupTop(this.compCode)
      .subscribe((data: UnitsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.unitsList[i] = data[i];
        }
        //console.log(data);
      });
  }
  retriveFinalUnitsLookupTop() {
    this.unitsService
      .getUnitsLookupTop(this.compCode)
      .subscribe((data: UnitsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.finalunitsList[i] = data[i];
        }
        //console.log(data);
      });
  }
  submitPrepDet_Line1() {

    this.PreMedicationSelectedData.prepautoserial = this.prepautoserial;
    this.PreMedicationSelectedData.prepmasterID = this.prepmasterID;
    this.PreMedicationSelectedData.patientID = this.patientcode;
    this.PreMedicationSelectedData.prepprotocolID = this.protocol;
    this.PreMedicationSelectedData.category = this.wk_category;
    this.PreMedicationSelectedData.drgserial = this.drgserial;
    this.PreMedicationSelectedData.drgName = this.drgName;
    this.PreMedicationSelectedData.perpDaose = this.perpDaose;
    this.PreMedicationSelectedData.cDSA = '0';
    this.PreMedicationSelectedData.uOM = this.uOM;
    this.PreMedicationSelectedData.prepDR = '0';
    this.PreMedicationSelectedData.prepFD = this.prepFD;
    this.PreMedicationSelectedData.prepFU = this.prepFU;

    this.PreMedicationSelectedData.prepdisp = this.prepdisp;
    this.PreMedicationSelectedData.prepsaved = this.prepsaved;
    this.PreMedicationSelectedData.cDSA = '0';
    this.PreMedicationSelectedData.prepRout = this.prepRout;
    this.PreMedicationSelectedData.prepDuration = this.prepDuration;
    this.PreMedicationSelectedData.prepImportant =  this.prepImportant;
    this.PreMedicationSelectedData.preSolution =  this.preSolution;
    this.PreMedicationSelectedData.prepTimeDone = formatDate(new Date(), 'HH:mm', 'en');
    this.PreMedicationSelectedData.prepDone = '0';
    this.PreMedicationSelectedData.prepPharmacy = '0';
    this.PreMedicationSelectedData.prepRout = this.prepRout;

    this.PreMedicationSelectedData.categoryName = this.PreMedicationSelectedData.categoryName ;
    this.PreMedicationSelectedData.userID = this.storage.retrieve('stguserId');
    this.PreMedicationSelectedData.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.PreMedicationSelectedData.compCode = this.storage.retrieve('stgcompCode');
    /////------------------- Modifay Line --------------
    this.preparationDetService.AddPrepDetCat_Line(this.PreMedicationSelectedData).subscribe(data => {},
      error => { alert(error); }
    );
    this.mesgSave();
    this.dialogRef.close();
  }

  ///----------- Delete Preapartion Detile Line -----------
deletePrepDetLine1(){
  console.log("A7A:",this.category)
  if (this.category !=''){  this.preparationDetService.DeletePrepDetLine(this.prepautoserial,this.category,this.drgserial, this.storage.retrieve('stgcompCode')).subscribe((data: PreparationDetModel) => {});};
  if (this.category ==''){  this.preparationDetService.DeletePrepDetLineSupp(this.prepautoserial,this.drgserial, this.storage.retrieve('stgcompCode')).subscribe((data: PreparationDetModel) => {});};


  this.dialogRef.close();
}
CloseDialog(){
  this.dialogRef.close();
}
mesgSave() {
  Swal({
    title: 'Your work has been saved',
    type: 'success',
    showConfirmButton: false,

    timer: 1500,
  });
}
mesgDelete() {

  Swal({
    title: 'Are you sure?',
    text: 'You will not be able to recover this record!',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then(() => {
      this.deletePrepDetLine1();
      Swal('Deleted!', 'Your record has been deleted.', 'success');

    },
    function (dismiss) {
      if (dismiss === 'cancel') {
        Swal('Cancelled', 'Your record is safe :)', 'error');
      }
    }
  );
}
}
